import React from 'react';
import styled from 'styled-components';
import cssIngka from '@ingka/variables/colours-css';

const LabelNote = styled.p`
  margin: 0 0 1rem;
  padding: 12px 16px;
  border-inline-start: 4px solid ${cssIngka.colourNeutral5};
  background: ${cssIngka.colourNeutral2};
  color: ${cssIngka.colourNeutral7};
`;

interface Text {
  text: string;
}

const AdditionalInformationLabel = (text: Text): JSX.Element => {
  return <LabelNote role="note">{text.text}</LabelNote>;
};

export default AdditionalInformationLabel;
